import React from 'react';
import { Redirect } from 'react-router-dom';

const PartialPackageDelivered = () => (
    <Redirect to="/panel-delivery-reports?tab=partial" />
);

export default PartialPackageDelivered;
